import React from 'react';
import styles from './ManagerWorkplaceItemButtons.module.scss';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';
import ManagerWorkplaceItemButtonsEdit from './ManagerWorkplaceItemButtonsEdit';
import ManagerWorkplaceItemButtonsSettings from './ManagerWorkplaceItemButtonsSettings';
import ManagerWorkplaceItemButtonsDelete from './ManagerWorkplaceItemButtonsDelete';

interface Props {
	item: WorkplacesTreeItem;
	openEditModal: (isOpen: boolean) => void;
	openDeleteModal: (isOpen: boolean) => void;
}

const ManagerWorkplaceItemButtons = ({
	item,
	openEditModal,
	openDeleteModal,
}: Props) => {
	const handleSettingsClick = () => {
		// @ts-ignore
		window.location.href = `/pracoviste/settings?id=${item.id}`;
	};

	return (
		<>
			{item.type === 'folder' && (
				<ManagerWorkplaceItemButtonsEdit
					onEditClick={() => openEditModal(true)}
				/>
			)}

			{item.type === 'normal' && (
				<div className={styles.buttonWrapper}>
					<ManagerWorkplaceItemButtonsSettings
						onSettingsClick={handleSettingsClick}
					/>
					<ManagerWorkplaceItemButtonsDelete
						onDeleteClick={() => openDeleteModal(true)}
					/>
				</div>
			)}
		</>
	);
};

export default ManagerWorkplaceItemButtons;
